// @flow

import { art as ENUM_ART } from 'Enum';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';

export const ArtFlatModel = {
  id: null,
  status: null,
  medium: null,
  title: null,
  width: null,
  height: null,
  unit: null,
  artistId: null,
  artistName: null,
  artistUrl: null,
  skuBuyPrice: null,
  skuRentPrice: null,
  url: null,
  store: {
    code: null,
  },
  file: {
    square: {
      height: null,
      width: null,
      url: null,
    },
    fluid: {
      height: null,
      width: null,
      url: null,
    },
  },
  is3D: null,
  isSoldOut: null,
  canBuy: null,
  canRent: null,
  collectionDescription: null,
};

/**
 * factoryFromArtFlat
 *
 * @param {Object} row
 * @param {Object} locale
 */
export const factoryFromArtFlat = (row: Object, locale: Object) => {
  const model = { ...ArtFlatModel };
  const imageFile =
    row.images &&
    row.images.map((item) =>
      item.type === ENUM_ART.image.type.TYPE_FLAT_SQUARE
        ? {
            sq: {
              file: item.file || { ...item },
            },
          }
        : {
            fl: {
              file: item.file || { ...item },
            },
          },
    );
  model.id = parseInt(row.id, 10);
  model.skuBuyId = row.skuBuyId;
  model.skuRentId = row.skuRentId;
  model.status = row.status;
  model.medium = row.medium;
  model.title = row.title;
  model.width = row.width;
  model.height = row.height;
  model.unit = row.unit;
  model.artistId = row.artistId;
  model.artistName = row.artistName;
  model.artistUrl = UrlAssembler.artistProfile(row.artistId, row.artistAlias, { locale });
  model.skuBuyPrice = row.skuBuyPrice;
  model.skuRentPrice = row.skuRentPrice;
  model.url = row.url;
  model.url = UrlAssembler.artDetail(row.id, row.slug, { locale });
  model.store = {
    code: row.storeCode || (row.store && row.store.code),
  };
  model.file = imageFile;
  model.canBuy = row.canBuy;
  model.canRent = row.canRent;
  model.isProduct = row.isProduct;
  model.isEnquire = row.isEnquire;
  model.isRented = row.isRented;
  model.isSoldOut = row.isSoldOut;
  model.collectionDescription = row.collectionDescription;
  model.is3D = row.is3D;

  return model;
};
